import { Button, Container, RadioGroup, FormControlLabel, Radio, Typography, Grid, TextField, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import React, { useEffect, useState } from 'react';
import * as azblob from '@azure/storage-blob';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));

const DigiSpanPraatForm = (props) => {

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }
        else {
            setInskrywingInfo({ ...inskrywing, "inskrywerId": props.userProf.userProfile.id })
        }

    }, [])

    const classes = useStyles();
    const [status, reportStatus] = useState('Oplaai het begin...');
    const [isUploading, setIsUploading] = useState(false);
    const [vid, setVid] = useState("GEEN");
    const [vidOpgelaai, setVidOpgelaai] = useState(false);
    const [formIsInValid, setFormIsInvalid] = useState(true);
    const [isBemagtig, setIsBemagtig] = useState(true);
    const [bewyse, setBewyse] = useState("GEEN");
    const [bewyseOpgelaai, setBewyseOpgelaai] = useState(false)

    const [inskrywing, setInskrywingInfo] = useState({
        "inskrywerId": "",
        "ouerNaamVan":"",
        "ouerSel": "",
        "ouerEpos": "",
        "spanVerwantskap": "",
        "kategorie": "",
        "sp1NaamVan": "",
        "sp1GeboorteDatum": "",
        "sp2NaamVan": "",
        "sp2GeboorteDatum": "",
        "sp3NaamVan": "",
        "sp3GeboorteDatum": "",
        "sp4NaamVan": "",
        "sp4GeboorteDatum": "",
        "onderwerp": "",
        "ouerBemagtigingGegee": false,
        "vidGelaai": false,
        "bewyseGelaai": false

    });
    const [inskrywingId, setInskrywingId] = useState();


    const accountName = "projektestorage";
    const sasString = process.env.REACT_APP_STORAGE_ACCOUNT_ACCESS_KEY;
    const containerName = "digispanpraat";
    const containerURL = new azblob.ContainerURL(
        `https://${accountName}.blob.core.windows.net/${containerName}?${sasString}`,
        azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));
    //const fileList = document.getElementById("file-list");
    const fileInput = document.getElementById("vid-input");
    const bewyseInput = document.getElementById("bewyse-input");


    const style = {

        padding: "20px",
    }


    const formChange = (e) =>
    {
        if (e.target.type === "radio") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.value });
        }
        else if (e.target.type === "checkbox") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.checked });

        }
        else {
            setInskrywingInfo({ ...inskrywing, [e.target.id]: e.target.value });
        }
    }

    const finishRegistration = async () => {
            //start upload ui
            setIsUploading(true);
            //insert record for inskrywing into db
        fetch('api/UserEntries/digispanpraat/new', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
               },
               body: JSON.stringify(inskrywing)
            })
                .then((response) => response.json())
               .then((data) => {
                   setInskrywingId(data.id);
                   //console.log('data logged as reposne', data);
               })

        }

    const uploadVidToBlob = async () => {
        //await finishSubmit();
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        for (const file of fileInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.ouerNaamVan + "-" + inskrywing.inskrywerId + "-inskrywing-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }
        for (const file of bewyseInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.ouerNaamVan + "-" + inskrywing.inskrywerId + "-inskrywing-bewyse-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }

        await Promise.all(promises);
        reportStatus("Sukses!");
        setIsUploading(false);
        window.setTimeout(props.history.push('suksesinskryf'), 500);
    }


    const vidInputChanged = () => {
        if (document.getElementById("vid-input").value != "") {
            setVid("Videomateriaal gekies!");
            setVidOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "vidGelaai": true })
        }
        else {
            setVid("");
            setVidOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "vidGelaai": false })


        }

    }

    const bewyseInputChange = () => {
        if (document.getElementById("bewyse-input").value != "") {
            setBewyse("Bewyse van betaling gekies!");
            setBewyseOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": true })
        }
        else {
            setBewyse("");
            setBewyseOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": false })


        }

    }

    //unneccessary for production
    useEffect(() => {
        //console.log('loigging props on digipraatform', props);
        console.log('logging inskrywing state', inskrywing);
    }, [])

    useEffect(() =>
    {
        if (inskrywingId !== undefined) {
            //wait for id to be returned before uploading video to azureblob
            //window.alert('BEGIN VIDEOMATERIAAL LAAI, ASSEBLIEF WEES GEDULDIG');
            uploadVidToBlob();
        }
    }, [inskrywingId])

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }

    }, [])

    useEffect(() =>
    {
        //as inskrywing verander, kyk of vorm leeg is

        //console.log('Inskrywing:', inskrywing);
        var isValid = true;

        for (var property in inskrywing) {
            if (property === "ouerBemagtigingGegee") {
                if (inskrywing["ouerBemagtigingGegee"] === false) {
                    isValid = false;
                }
            }
            else if (property === "vidGelaai") {
                if (inskrywing["vidGelaai"] === false) {
                    isValid = false;
                }
            }
            else if (property === "bewyseGelaai") {
                if (inskrywing["bewyseGelaai"] === false) {
                    isValid = false;
                }
            }

            else if (inskrywing[property] === "") {
                isValid = false;
            }
            //console.log(`key= ${property} value = ${inskrywing[property]}`)
        }
        if (isValid) {
            setFormIsInvalid(false);
        }
        else {
            setFormIsInvalid(true);
        }
        console.log('inskrywing useffect:', inskrywing);

    }, [inskrywing])


    return (
        <Container className="container" style={style}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Ouer/voog/afrigter/skakelpersoon of spanlid se besonderhede</Typography>

                    <TextField onChange={formChange} id="ouerNaamVan" label="Naam en van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouerSel" label="Selfoonnommer" variant="outlined" margin="normal"  fullWidth />

                    <TextField onChange={formChange} id="ouerEpos" label="E-posadres" variant="outlined" margin="normal" type="email" fullWidth />

                    <Typography variant="h5" gutterBottom>Spanverwantskap</Typography>

                    <RadioGroup name="spanVerwantskap" aria-label="spanVerwantskap" onChange={formChange}>
                        <FormControlLabel value="ouer" control={<Radio color="primary" />} label="Ouer" />
                        <FormControlLabel value="voog" control={<Radio color="primary" />} label="Voog" />
                        <FormControlLabel value="afrigter" control={<Radio color="primary" />} label="Afrigter" />
                        <FormControlLabel value="skakelpersoon" control={<Radio color="primary" />} label="Skakelpersoon" />
                        <FormControlLabel value="spanlid" control={<Radio color="primary" />} label="Spanlid" />
                    </RadioGroup>


                    <Typography variant="h5" gutterBottom>Ouermagtiging</Typography>
                    <Grid container>
                        <Grid item xs={2} lg={2}>
                            <Checkbox
                                onChange={formChange}
                                color="primary"
                                name="ouerBemagtigingGegee"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </Grid>
                        <Grid item xs={10} lg={10}>
                            <Typography variant="h6" gutterBottom>
                                {
                                    //important notice to be ticked
                                }
                                    Hiermee gee ek toestemming dat my kind aan ATKV-DigiSpanpraat mag deelneem. Ek gee toestemming dat my kind se video op enige sosialemediaplatform van die ATKV geplaas mag word.                        </Typography>
                        </Grid>
                    </Grid>


                </Grid>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Spanbesonderhede</Typography>

                    <Typography variant="h6" gutterBottom>Kategorie</Typography>

                    <RadioGroup name="kategorie" aria-label="kategorie" onChange={formChange}>
                        <FormControlLabel value="afrikaanshuistaal" control={<Radio color="primary" />} label="Afrikaans Huistaal" />
                        <FormControlLabel value="tweetalig" control={<Radio color="primary" />} label="Tweetalig (Afrikaans en Engels)" />
                        <FormControlLabel value="familie" control={<Radio color="primary" />} label="Familie" />
                    </RadioGroup>

                    <Typography variant="h6" gutterBottom>Spreker 1</Typography>
                    <TextField onChange={formChange} id="sp1NaamVan" label="Spreker 1: Naam en Van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="sp1GeboorteDatum" label="Spreker 1: Geboortedatum (JJJJ/MM/DD)" variant="outlined" margin="normal" fullWidth />
                    <Typography variant="h6" gutterBottom>Spreker 2</Typography>
                    <TextField onChange={formChange} id="sp2NaamVan" label="Spreker 2: Naam en Van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="sp2GeboorteDatum" label="Spreker 2: Geboortedatum (JJJJ/MM/DD)" variant="outlined" margin="normal" fullWidth />
                    <Typography variant="h6" gutterBottom>Spreker 3</Typography>
                    <TextField onChange={formChange} id="sp3NaamVan" label="Spreker 3: Naam en Van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="sp3GeboorteDatum" label="Spreker 3: Geboortedatum (JJJJ/MM/DD)" variant="outlined" margin="normal" fullWidth />
                    <Typography variant="h6" gutterBottom>Spreker 4</Typography>
                    <TextField onChange={formChange} id="sp4NaamVan" label="Spreker 4: Naam en Van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="sp4GeboorteDatum" label="Spreker 4: Geboortedatum (JJJJ/MM/DD)" variant="outlined" margin="normal" fullWidth />
                    <Typography variant="h6" gutterBottom>Toespraak</Typography>
                    <TextField onChange={formChange} id="onderwerp" label="Onderwerp" variant="outlined" margin="normal" fullWidth />


                    <div className={classes.root}>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Kies videomateriaal
  <input
                                id="vid-input"
                                type="file"
                                accept="video/*"
                                style={{ display: "none" }}
                                onChange={vidInputChanged}

                            />
                        </Button>
                        {vidOpgelaai ? <p> {vid} </p> : <p> </p>}

                    </div>
                    {/* 
                     * Bewys van betaling
                     */}
                    <div className={classes.root}>
                        <Typography variant="h6" gutterBottom>Bewys van betaling</Typography>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Betalingsoplaaifunksie
                        <input
                                id="bewyse-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={bewyseInputChange}
                                accept=".pdf"

                            />
                        </Button>
                        {bewyseOpgelaai ? <p> {bewyse} </p> : <p> </p>}

                    </div>
                    {/* 
                     * END Bewys van betaling END
                     */}

                </Grid>
                <Grid container justify="center">
                    {isUploading ? <Grid item> <CircularProgress /> <Typography variant="body1" gutterBottom>{status}</Typography> </Grid> : <br />}
                </Grid>

                <Grid container justify="center">
                    <Grid>
                        <Button variant="contained" size="large" color="primary" disabled={formIsInValid} onClick={finishRegistration}>Registreer vir ATKV-DigiSpanpraat</Button>

                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )

}


export default DigiSpanPraatForm;


// WEBPACK FOOTER //
// ./src/components/inskrywingsvorms/DigiSpanPraatForm.js